/* @flow strict */

/* eslint-disable camelcase */
/* eslint-disable max-params */

import * as React from 'react';

export const sponsorColumns = (
  handleSelectRow: () => void,
  selectedRow: string | number,
  handleGetUsers: () => void,
): [] => [
  {
    selector: '',
    name: '',
    sortable: false,
    width: '50px',
    cell: (row: {}): React.Element<'input'> => {
      return (
        <input
          type="checkbox"
          checked={`${row.id}` === `${selectedRow ? selectedRow.id : null}`}
          onChange={() => {
            if (`${row.id}` === `${selectedRow ? selectedRow.id : null}`) {
              handleSelectRow({});
            } else {
              handleSelectRow(row);
            }
          }}
        />
      );
    }
  },
  {
    selector: 'name',
    name: 'Sponsor Name',
    sortable: true,
    cell: (row: {}): React.Element<'input'> => {
      return (
        <span style={{ color: '#009BFF', cursor: 'pointer' }} onClick={(): void => handleGetUsers(row.id)}>
          {row.name}
        </span>
      );
    }
  },
  {
    selector: 'login_count',
    name: 'Number of Users',
    sortable: true
  }
];

export const usersColumns = (
  handleUsersSelectRow: () => void,
  selectedUsersRows: string | number,
): [] => [
  {
    selector: '',
    name: '',
    sortable: false,
    width: '50px',
    cell: (row: {}): React.Element<'input'> => {
      return (
        <input
          type="checkbox"
          checked={`${row.id}` === `${selectedUsersRows ? selectedUsersRows.id : null}`}
          onChange={() => {
            if (`${row.id}` === `${selectedUsersRows ? selectedUsersRows.id : null}`) {
              handleUsersSelectRow({});
            } else {
              handleUsersSelectRow(row);
            }
          }}
        />
      );
    }
  },
  {
    selector: 'email',
    name: 'User Email',
    sortable: true
  },
  {
    selector: 'first_name',
    name: 'First name',
    sortable: true
  },
  {
    selector: 'last_name',
    name: 'Last name',
    sortable: true
  }
];
